import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import { ReleaseRef } from 'hooks/data/versions/types';
import { useResolvedRelease } from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

import { v4Dataset, FetchDatasetParams } from '../types';

const fetchV4Dataset = async (params: FetchDatasetParams) => {
  const { data } = await api.get(`/web/v4/uprs/${params.dataset_id}`, { params });

  return data;
};

const useV4Dataset = (id?: string, release?: ReleaseRef) => {
  const { version, system_model } = useResolvedRelease(release);
  return useQuery<v4Dataset, AxiosError>({
    queryKey: ['datasetV4', id, version, system_model],
    queryFn: () => fetchV4Dataset({ dataset_id: id as string, version, system_model }),
    enabled: isV4Release(version) && !!id,
    retry: false,
  });
};

export default useV4Dataset;
